// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__dSwP+","dividerVertical":"Divider_dividerVertical__e4813","colorSecondary":"Divider_colorSecondary__UVE4-","colorTertiary":"Divider_colorTertiary__PQHvP"};